import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DocStereoTypeDto, DocStereoTypesDto, GenericDocumentData } from 'shared';
import { ProjectDto } from 'shared';
import { SquirrelSessionRequest } from 'shared';
import { DataSharingService } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { ProjectService } from 'shared';
import { TranslateService } from 'shared';

import { GenericFilter } from 'shared';
import { Observable } from 'rxjs';
import { ProjectGroupRolePermissionService } from 'shared';
import { TenantService } from 'shared';
import { EventsService } from 'shared';
import { SquirrelManagementService } from 'shared';
import { DatabaseMigrationService } from 'shared';
import { TenantDbVersion } from 'shared';
import { ConfirmDbwarningDialogComponent } from './confirm-dbwarning-dialog/confirm-dbwarning-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LayoutStateService } from 'shared';

interface SortOption {
  value: string;
  label: string;
}

@Component({
    selector: 'project-list',
    templateUrl: './project-list.component.html',
    styleUrls: ['./project-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProjectListComponent implements OnInit {

  _db:string = "";

  squirrelSessionRequest!: SquirrelSessionRequest;

  selectedRow: any;
  selectedRows!: number;

  project!: ProjectDto;

  docStereoTypesDto!: DocStereoTypesDto;
  docStereoTypeDto!: DocStereoTypeDto;
  docStereoTypeDtos!: DocStereoTypeDto[];

  docStType$!: Observable<DocStereoTypeDto[] | undefined>;

  genericDocumentData!: GenericDocumentData;

  projects: ProjectDto[] = [];
  filter!: GenericFilter;
  sq_spinner: any = './assets/img/sq-spinner.gif';

  isLoadingResults = true;
  isRateLimitReached = false;
  checked = false;

  searchTerm = '';
  sortMenuOpen = false;
  selectedSort = 'nameAsc';
  sortOptions: SortOption[] = [
    { value: 'nameAsc', label: 'Name A-Z' },
    { value: 'nameDesc', label: 'Name Z-A' },
    { value: 'oldestFirst', label: 'Älteste zuerst' },
    { value: 'newestFirst', label: 'Neueste zuerst' },
  ];

  minDateTime = new Date("0001-01-01T00:00:00");

  tenantVersions!: TenantDbVersion;
  frontendUrl!: string;

  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    private oauthService: OAuthServiceService,
    private projectService: ProjectService,
    private dataSharingService: DataSharingService,
    private notificationService: NotificationService,
    private projectGroupRolePermissionsService: ProjectGroupRolePermissionService,
    private tenantService: TenantService,
    private eventsService:EventsService,
    private managementService: SquirrelManagementService,
    private databaseMigrationService: DatabaseMigrationService,
    private layoutStateService: LayoutStateService,

    ) { }

  get filteredProjects(): ProjectDto[] {
    let list = this.projects;
    if (this.searchTerm) {
      const term = this.searchTerm.toLowerCase();
      list = list.filter(p => p.display_Name?.toLowerCase().includes(term));
    }
    const sorted = [...list];
    switch (this.selectedSort) {
      case 'nameAsc':
        sorted.sort((a, b) => a.display_Name.localeCompare(b.display_Name));
        break;
      case 'nameDesc':
        sorted.sort((a, b) => b.display_Name.localeCompare(a.display_Name));
        break;
      case 'newestFirst':
        sorted.sort((a, b) => new Date(b.createdWhen).getTime() - new Date(a.createdWhen).getTime());
        break;
      case 'oldestFirst':
      default:
        sorted.sort((a, b) => new Date(a.createdWhen).getTime() - new Date(b.createdWhen).getTime());
        break;
    }
    return sorted;
  }

  get currentSortLabel(): string {
    return this.sortOptions.find(o => o.value === this.selectedSort)?.label ?? '';
  }

  setSort(value: string): void {
    this.selectedSort = value;
  }

  getInitials(displayName: string): string {
    if (!displayName) return '';
    const parts = displayName.trim().split(/\s+/);
    return parts.length > 1
      ? (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
      : displayName.substring(0, 2).toUpperCase();
  }

  ngOnInit(): void {

    this.squirrelSessionRequest = new SquirrelSessionRequest();

    this.filter = new GenericFilter();
    this.filter.className = 'Project';

    this.loadProjects();

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = (data as any).role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
              this._db = dbrole;
              }
          });
        }
      }
    });

    this.tenantService.getTenant(this.tenantService.currentTenantId).subscribe({
      next: (tenantDto) => {
        this.frontendUrl = tenantDto.frontendUrl;
        console.log("------------> project-list: tenant frontendUrl = ", tenantDto.frontendUrl)

        this.layoutStateService.setSidebarVisible(true);
        this.layoutStateService.setBreadcrumbs([
          { label: 'Mandanten', path: ['/', 'select-tenant'] },
          { label: tenantDto.displayName }
        ]);
      },
      error: (error: any) => {
        //this.errorMessage = ErrorFormat.formatError(error);
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting tenant frontendUrl")
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> project-list: tenant db = ", error.error.developerMessage);
      }
    });

    //check if DB Version is up to date
    this.databaseMigrationService.getCurrentTenantDbVersion(this.tenantService.currentTenantName).subscribe({
      next: (version: TenantDbVersion) => {
        this.tenantVersions = version;
        console.log("------------> database-updates: tenant versions = ", version.dbVersion + " - " + version.requiredDbVersion);
        if (version.dbVersion != version.requiredDbVersion) {
          const dialogRef = this.dialog.open(ConfirmDbwarningDialogComponent, {width: '500px',data:null });
          dialogRef.afterClosed().subscribe((result:any) => {
            //if (result) {}
          });
        }
        this.checked = true;
      },
      error: (error: any) => {
        //this.errorMessage = ErrorFormat.formatError(error);
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting tenant versions")
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> project-list: tenant db = ", error.error.developerMessage);
      }
    });
  }

  loadProjects(): void {
    this.isLoadingResults = true;

    const db = this.tenantService.currentTenantName;

    this.tenantService.getUserProjects(this.filter, db).subscribe({
      next: (data) => {

        this.projects = data.filter(x =>
          new Date(x.archivedWhen).getTime() === this.minDateTime.getTime() ||
          x.archivedWhen == null
        );

        this.isLoadingResults = false;

        if (this.projects.length === 0) {
          this.notificationService.info(
            `${this.translate.data["INFO"]}`,
            `${this.translate.data["NOPROJECTSRETRIEVED"]}`
          );
        }
      },

      error: (error: any) => {
        this.isLoadingResults = false;
        this.isRateLimitReached = true;

        this.notificationService.error(
          `${this.translate.data["ERROR"]}`,
          `${this.translate.data["PROJECTRETRIVALERROR"]}`
        );

        console.log("-----------> project-list: error = ", error.error.developerMessage.Message);
        this.notificationService.info("", error.error.developerMessage.Message);
      }
    });
  }

  onRowClicked(project: ProjectDto): void {

    let db:string = this.tenantService.currentTenantName;
    console.log("--------> project-list frontendUrl = ", this.frontendUrl)
    this.managementService.GetSq3ProjectAuthentificationId(db, project.id).subscribe({
      next: (sessionId) => {
        window.open(`${this.frontendUrl}/?tenant=${db}&sessionId=${sessionId}`, '_blank');
      },
      error: () => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "management project authentication error")
      }
    })
  }
}
